import { useState } from "react";
import { SampleRequestService } from "../../../../Services/SampleRequest.Service";
import Toaster from "../../../../Components/Toaster";
import Loader from "../../../../Components/Loader";

function HealthDataDownloadButton({requestId, donorId, type}){
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [loading, setLoading] = useState(false);
    

   function downloadHealthData(e) {
    e.preventDefault(); // stop form/page reload

    setLoading(true);
    SampleRequestService.downloadHealthData(requestId, donorId)
        .then((res) => {
            if (res.success) {
                const downloadUrl = res.download_url;

                const link = document.createElement("a");
                link.href = downloadUrl;

                const filename =
                    downloadUrl.split("/").pop() ||
                    `healthdata_${requestId}_${donorId}.pdf`;

                link.setAttribute("download", filename);
                link.setAttribute("target", "_blank"); // avoid replacing page

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setShowToast(true);
                setToastMessage(res.message);
                setToastVariant("success");
            } else {
                setShowToast(true);
                setToastMessage(res.message || "Failed to download health data");
                setToastVariant("danger");
            }
        })
        .catch((error) => {
            setShowToast(true);
            setToastMessage("Error downloading health data.");
            setToastVariant("danger");
            console.error("Error downloading health data:", error);
        })
        .finally(() => {
            setLoading(false);
        });
    }

    return(<>
        {type === 'label' ? (
            <span 
            className="el-link-button"
            onClick={downloadHealthData}>
            <span>Download Health Data</span>
        </span>
        ) :  <button
            type="button"
            className="el-main-button  ms-2 p-2 px-4"
            onClick={downloadHealthData}>
            <span>Download Health Data</span>
        </button>}
        <Loader loading={loading} />
        <Toaster
            show={showToast}
            message={toastMessage}
            variant={toastVariant}
            onClose={() => setShowToast(false)}
        />
    </>)
}
export default HealthDataDownloadButton;